import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { RouterModule } from "@angular/router";
import { CopyrightBlockComponent } from "@app/core/components/copyright-block/copyright-block.component";
import { SharedModule } from "../shared/shared.module";
import { AuthRoutingModule } from "./auth-routing.module";
import { AuthButtonComponent } from "./components/auth-button/auth-button.component";
import { EmailFormComponent } from "./components/email-form/email-form.component";
import { ForgotPasswordComponent } from "./components/forgot-password/forgot-password.component";
import { LoginBackgroundComponent } from "./components/login-background.component";
import { LoginContainerComponent } from "./components/login-container/login-container.component";
import { LoginInterstitialComponent } from "./components/login-interstitial.component/login-interstitial.component";
import { LoginPageComponent } from "./components/login-page/login-page.component";
import { LogoutConfirmationDialogComponent } from "./components/logout-confirmation/logout-confirmation-dialog/logout-confirmation-dialog.component";
import { MobilePasswordResetLandingPageComponent } from "./components/mobile-password-reset-landing-page/mobile-password-reset-landing-page.component";
import { RegisterFormComponent } from "./components/register-form/register-form.component";
import { RegisterPageComponent } from "./components/register-page/register-page.component";
import { ResetPasswordSentComponent } from "./components/reset-password-sent/reset-password-sent.component";
import { ResetPasswordComponent } from "./components/reset-password/reset-password.component";
import { AuthUserDbService } from "./services/auth-user-db.service";
import { UpdateLoginWarningComponent } from "./components/update-login-warning/update-login-warning.component";
import { SocialSignInBlockComponent } from "./components/social-sign-in-block/social-sign-in-block.component";

export const COMPONENTS = [
    EmailFormComponent,
    AuthButtonComponent,
    RegisterPageComponent,
    RegisterFormComponent,
    LoginPageComponent,
    LogoutConfirmationDialogComponent,
    ForgotPasswordComponent,
    LoginInterstitialComponent,
    CopyrightBlockComponent,
    LoginContainerComponent,
    ResetPasswordComponent,
    MobilePasswordResetLandingPageComponent,
    LoginBackgroundComponent,
    ResetPasswordSentComponent,
    UpdateLoginWarningComponent,
    SocialSignInBlockComponent,
];

@NgModule({
    imports: [
        FlexLayoutModule,
        AuthRoutingModule,
        CommonModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
        MatDialogModule,
        MatButtonModule,
        SharedModule,
        ReactiveFormsModule,
        RouterModule,
    ],
    declarations: COMPONENTS,
    providers: [AuthUserDbService],
})
export class AuthModule {}
